export const sectionUrlToLink = (location: any, sectionUrl: string) => {
  return sectionUrl.replace(location.baseUrl, '').split('?', 2)[0];
};
